// Single source of truth for product naming.
export const BRAND = {
  company: "GenAICore",
  product: "Nexus",
  name: "GenAICore Nexus",
  tagline: "One API for every model.",
  description: "Route, observe and control 20+ LLM providers from one gateway.",
} as const;
